import ParcelShieldUsers from "@/components/parcelshieldusers/ParcelShieldUsers";
export default [
  {
    path: "/parcelshieldusers",
    name: "ParcelShieldUsers",
    component: ParcelShieldUsers,
    meta: {
      requiresAuthentication: true
    }
  }
];
